import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../store/actions/leaveActions';

import ReactDOM from "react-dom";
// import axios from 'axios';
import Select from 'react-select';
import _ from 'lodash';
import DatePicker from "react-datepicker";
import { TimeInputFormat, DateInputFormat } from "../common/DateComponents";
import "react-datepicker/dist/react-datepicker.css";
import 'react-notifications/lib/notifications.css';
import { format, setHours, setMinutes, setSeconds, setDate, differenceInDays, differenceInMinutes } from 'date-fns'
import { v4 as uuidv4 } from 'uuid';
import { XMarkIcon } from '@heroicons/react/20/solid'
import Spinner from "../common/Spinner";

const CommentModal = ({
  leave,
  currentDepartment,
  leaveType,
  showComments,
  modalSaving,
  userPermissions,
  currentLeave,
  saveLeave,
  // mySaveLeave
}) => {

  const [comment, setComment] = useState();

  if (!leave) return null

  const saveLeaveData = () => {

    const leaveData = {
      ...leave,
      comment,
      agreement: leave.agreementID || leave.agreementId || leave.agreement,
    }

    saveLeave(leaveData);
    showComments(null);
    setComment(null)
  }

  return (
    <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="block block-themed block-transparent remove-margin-b">
            <div className="block-header bg-primary-dark">
              <ul className="block-options">
                <li>
                  <button type="button" onClick={() => { showComments(null) }}>
                    <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                  </button>
                </li>
              </ul>
              <h3 className="block-title">Comments for {leaveType} Leave {format(new Date(leave.date), "do MMM yyyy")}</h3>
            </div>
            <div className="block-content">

              {leave.comments.map(comment => (
                  <div>
                    <span style={{
                      fontWeight: "bold"
                    }}>{comment?.byName || ''}</span>
                    <span style={{
                      fontSize: "12px"
                    }}> - {format(new Date(comment.createdAt || leave.date), "do MMM yyyy HH:mm")}</span>
                    <p>{comment?.comment || comment}</p>

                  </div>
                ))
              }
              {userPermissions != 'Read' &&
                <div className="form-group">
                  <div className="col-sm-12">
                    <label>Add Comment</label>
                    <textarea
                      className="form-control form-input"
                      name="comment"
                      onChange={(e) => {
                        setComment(e.target.value)
                      }}
                    >{comment}</textarea>
                    <div className="clearfix" />
                  </div>
                  <div className="clearfix" />
                </div>
              }

              {comment &&
                <button className="btn btn-success pull-right" onClick={() => saveLeaveData()} style={{ marginRight: 0, marginBottom: "20px" }}>Save Comment</button>
              }

              {!comment &&
                <button className="btn btn-default pull-right" style={{ marginRight: 0, marginBottom: "20px" }} onClick={() => { showComments(null) }}>Close</button>
              }

              {
                modalSaving &&
                <button className="btn btn-success pull-right" style={{ marginRight: 0 }}>
                  <Spinner
                    style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                    className="animate-spin -ml-1 mr-3 h-5 w-5 "
                  />
                  <div style={{ float: 'left' }}>Saving</div>
                </button>
              }
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {


  const { leaveTypes } = state.leave?.leaveSettings || {}


  const leave = state.leave.showComments;
  const userPermissions = state?.permissions?.my?.permissions?.leave

  return {
    userPermissions,
    modalSaving: state.leave.modalSaving,
    leave,
    leaveType: leaveTypes && leave && _.find(leaveTypes, ({ id }) => id == leave.type)?.name,
  }
}

const mapDispatchToProps = dispatch => ({
  showComments: (leave) => dispatch(ACTIONS.showComments(leave)),
  saveLeave: (leave) => dispatch(ACTIONS.saveLeave(leave)),
  // mySaveLeave: (timesheet) => dispatch(MYACTIONS.mySaveLeave(timesheet)),
  // timesheetUpdateSaveStatus: (status) => dispatch(ACTIONS.timesheetUpdateSaveStatus(status))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommentModal) 
